const { get, uniq, isEmpty } = require("lodash");
const typeFactory = require("./types");

function validateOneCriteria(criteria, answers, keyTypeRelation) {
  /** check every eligibility criteria to validate */
  return Object.keys(criteria).every((key) => {
    const eligibility = criteria[key];
    const answer = answers[key];
    const type = get(
      keyTypeRelation.find((kt) => kt.key === key),
      "type"
    );
    return typeFactory(type).validate({ eligibility, answer });
  });
}

function paramString(something) {
  return typeof something === "string" ? JSON.parse(something) : something;
}

/**
 * Validate answers using eligibility criteria rules.
 *
 * @param {string|Object[]} eligibilityCriteria - Eligibility criteria rules. Evaluated with OR relation.
 * @param {string} eligibilityCriteria[].key - The question id.
 * @param {string} eligibilityCriteria[].value- The expected answer.
 * @param {string|Object} answers - Answers provided by the user (candidate, participant ...).
 * @param {string} answers.key - The question id.
 * @param {string} answers.value - The answer value.
 * @param {Object[]} keyTypeRelations - Question's types. Tip: you can use directly questions from a questionnaire due to the same structure.
 * @param {string} keyTypeRelations[].key - The question id.
 * @param {string} keyTypeRelations[].type - The type (e.g. "yesno", "bmi", "select" ...)
 * @returns {boolean} - Provided answers match any eligibility criteria rule.
 */
function validateAnswers(eligibilityCriteria, answers, keyTypeRelations) {
  const criteriaJson = paramString(eligibilityCriteria);
  const answersJson = paramString(answers);
  const relationsJson = paramString(keyTypeRelations);

  const studyIds = criteriaJson
    .filter((x) => validateOneCriteria(x.criteria, answersJson, relationsJson))
    .flatMap((x) => x.studyIds);

  return { eligible: !isEmpty(studyIds), studyIds: uniq(studyIds) };
}

module.exports = validateAnswers;
